import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

let compteur = 0;

/** Montant en FCFA : clavier numérique, séparateurs de milliers pendant la saisie, entier positif */
@Component({
  selector: 'bay-money-input',
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MoneyInputComponent), multi: true }],
  template: `
    <div class="bay-money" [class.is-invalid]="invalid" [class.bay-money-lg]="size === 'lg'">
      <input #input [id]="inputId" type="text" inputmode="numeric" autocomplete="off" class="bay-money-input"
        [attr.aria-invalid]="invalid || null" [attr.aria-describedby]="describedBy || null"
        [placeholder]="placeholder" [disabled]="disabled" [value]="affiche"
        (input)="onInput($any($event.target).value)" (blur)="onTouched()" (focus)="$any($event.target).select()">
      <span class="bay-money-unit" aria-hidden="true">FCFA</span>
    </div>
  `
})
export class MoneyInputComponent implements ControlValueAccessor {
  @Input() inputId = `bay-money-${++compteur}`;
  @Input() placeholder = '0';
  @Input() invalid = false;
  @Input() describedBy = '';
  @Input() size: 'md' | 'lg' = 'md';
  @Output() valeur = new EventEmitter<number | null>();
  @ViewChild('input') input?: ElementRef<HTMLInputElement>;

  affiche = '';
  disabled = false;
  private onChange: (v: number | null) => void = () => {};
  onTouched: () => void = () => {};

  writeValue(v: number | null): void {
    this.affiche = v == null || (v as any) === '' ? '' : this.format(Math.round(+v));
  }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState(d: boolean): void { this.disabled = d; }

  onInput(brut: string): void {
    const chiffres = (brut || '').replace(/\D/g, '').slice(0, 12);
    const n = chiffres ? parseInt(chiffres, 10) : null;
    this.affiche = n == null ? '' : this.format(n);
    if (this.input) this.input.nativeElement.value = this.affiche;
    this.onChange(n);
    this.valeur.emit(n);
  }

  focus(): void { this.input?.nativeElement.focus(); }

  private format(n: number): string {
    return n.toLocaleString('fr-FR').replace(/ | /g, ' ');
  }
}
